<template>
  <el-container style="width:100%;">
    <!-- <el-header>
      <el-row type="flex" align="middle">
        <el-col :span="6" style="padding-top: 10px;">
          <el-button round @click="onRefersh()">{{generateCustomizeString('refresh')}}</el-button>
        </el-col>
      </el-row>
    </el-header> -->
    <el-main>
      <el-table :data="promotionCouponUrlData" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="promotionListLoading" v-if="this.isCouponEnabled === 1">
        <el-table-column prop="title" :label="generateCustomizeString('promotion')" width="220">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="url" :label="generateCustomizeString('promotionGoodsListUrl')">
          <template slot-scope="scope">
            <a :href="mobileUrl + '/' + scope.row.mobile_url" target="_blank">
              <span>{{ mobileUrl + '/' + scope.row.mobile_url }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="pc_url" :label="generateCustomizeString('promotionGoodsListPCUrl')">
          <template slot-scope="scope">
            <a :href="pcUrl + '/promotion/' + scope.row.pc_url" target="_blank">
              <span>{{ pcUrl + '/promotion/' + scope.row.pc_url }}</span>
            </a>
          </template>
        </el-table-column>
      </el-table>
      <el-table :data="promotionUrlData" tooltip-effect="dark" style="width: 100%; margin-bottom:60px;"  v-loading.body="promotionListLoading" v-else>
        <el-table-column prop="title" :label="generateCustomizeString('promotion')" width="220">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="url" :label="generateCustomizeString('promotionGoodsListUrl')">
          <template slot-scope="scope">
            <a :href="mobileUrl + '/' + scope.row.mobile_url" target="_blank">
              <span>{{ mobileUrl + '/' + scope.row.mobile_url }}</span>
            </a>
          </template>
        </el-table-column>
        <el-table-column prop="pc_url" :label="generateCustomizeString('promotionGoodsListPCUrl')">
          <template slot-scope="scope">
            <a :href="pcUrl + '/' + scope.row.pc_url" target="_blank">
              <span>{{ pcUrl + '/' + scope.row.pc_url }}</span>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'

export default {
  name: 'PromotionUrl',
  data() {
    return {
      promotionListLoading: false,
      promotionUrlData: [],
      promotionCouponUrlData: [],
      mobileUrl: this.$store.state.shop.shop_custom_host
        ? 'http://' + this.$store.state.shop.shop_custom_host
        : process.env.VUE_APP_MOBILE_URL + this.$store.state.shop.shop_domain_prefix,
      pcUrl: this.$store.state.shop.shop_pc_url,
      shopId: '',
      isCouponEnabled: this.$store.state.shop.is_coupon_enabled
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      // this.$router.replace({
      //   name: 'PromotionUrl'
      // })
    },
    fetchShopBasic() {
      request({
        url: '/basic',
        method: 'get'
      })
        .then(response => {
          this.shopId = response.data.id
        })
        .catch(error => {
          console.warn(error)
        })
    },
    fetchPromotionUrlData() {
      this.promotionUrlData = [{
        name: this.generateCustomizeString('gift'),
        mobile_url: 'gift',
        pc_url: 'gift'
      },
      {
        name: this.generateCustomizeString('freeShipping'),
        mobile_url: 'free-shipping',
        pc_url: 'free-shipping'
      },
      {
        name: this.generateCustomizeString('limitedTimeSpecial'),
        mobile_url: 'module/time-special',
        pc_url: 'product/list?actionUrl=time-special&activityTitle=限时特价'
      }]
      this.promotionCouponUrlData = [{
        name: this.generateCustomizeString('gift'),
        mobile_url: 'gift',
        pc_url: 'gift'
      },
      {
        name: this.generateCustomizeString('freeShipping'),
        mobile_url: 'free-shipping',
        pc_url: 'free-shipping'
      },
      {
        name: this.generateCustomizeString('limitedTimeSpecial'),
        mobile_url: 'module/time-special',
        pc_url: 'product/list?actionUrl=time-special&activityTitle=限时特价'
      },
      {
        name: this.generateCustomizeString('couponCollectCenter'),
        mobile_url: 'coupon-collect',
        pc_url: 'coupon'
      }]
    }
  },
  created() {
    if (location.host.includes('ieshop.co.nz')) {
      const shop_domain_prefix = this.$store.state.shop.shop_domain_prefix
      this.mobileUrl = 'https://m.ieshop.co.nz/m/' + shop_domain_prefix
      if (this.pcUrl.includes('nzmai.com.cn')) {
        this.pcUrl = 'https://' + shop_domain_prefix + '.ieshop.co.nz'
      }
    }
    this.fetchShopBasic()
    this.fetchPromotionUrlData()
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .el-header,
  .el-footer {
    background-color: #eee;
    color: #333;
  }
</style>
